export enum UserActions {
    DUMMY = 0,
    READ = 1,
    UPDATE = 2,
    DELETE = 3,
    INSERT = 4
}